import { Injectable } from '@angular/core';
import { LoggerService } from 'BI-Libraries/BI-Components/dist/bi-modules';

@Injectable({
  providedIn: 'root'
})
export class AlertsService {

  constructor(public loggerService: LoggerService) { }
  showAlertMessage(content: string, type: number) {
    this.loggerService.Content = content;
    this.loggerService.Type = type;
    this.loggerService.Show();
  }
}
